<template>
  <div class="create-playlist-modal" id="create-playlist-modal-dom">
    <BModal :active="isModalOpen" :can-cancel="false">
      <div style="display: flex; width: 100%; justify-content: center">
        <div
          class="create-playlist-modal__content"
          :class="showAddToPlaylist ? 'is-small-modal' : 'is-big-modal'"
          :style="`width: ${modalWidth}; max-width: ${modalMaxWidth}`"
        >
          <div v-if="showAddIcon" class="add-img-playlist">
            <div class="add-img-playlist__header">
              <div class="add-img-playlist__header__back" @click="backAddIconToPlaylist">
                <div class="add-img-playlist__header__back__button">
                  <div class="add-img-playlist__header__back__button__icon">
                    <img src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_back.svg" />
                  </div>
                  <div>
                    Volver
                  </div>
                </div>
              </div>
              <div class="add-img-playlist__header__title">
                <span class="add-img-playlist__header__title__text">Selecciona un ícono predeterminado</span>
              </div>
              <div class="add-img-playlist__header__icon" @click="clickCloseModal">
                <img src="https://golstatsimages.blob.core.windows.net/todoelfut/close-blue.png" />
              </div>
            </div>
            <div class="add-img-playlist__contimgs">
              <div
                v-for="(imgUrl, index) of playlistImages"
                :key="index"
                class="item-icon-select"
                :class="{ selected: selectedIconIndex === index }"
                @click="onClickImage(imgUrl, index)"
              >
                <img :src="imgUrl" />
              </div>
            </div>
            <div class="add-img-playlist__btnscontent">
              <div v-show="false" class="btn-add-playlist-cancel-3">
                <span class="btn-add-playlist-cancel-3__text">Adjuntar</span>
                <img src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_image@2x.png" />
              </div>
              <div class="btn-add-playlist-save-3" @click="saveAddIconToPlaylist">
                Aplicar
              </div>
            </div>
          </div>
          <div v-if="showCreateForm" class="create-playlist">
            <div class="create-playlist__header">
              <div class="create-playlist__header__title">
                <img src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_add_folder_playlist@2x.png" />
                <span class="create-playlist__header__title__text">Crear playlist</span>
              </div>
              <div class="create-playlist__header__icon" @click="clickCloseModal">
                <img src="https://golstatsimages.blob.core.windows.net/todoelfut/close-blue.png" />
              </div>
            </div>
            <div class="create-playlist__form">
              <div class="create-playlist__form__imgcont" :style="formIconStyle" @click="clickAddIconToPlaylist"></div>
              <div class="create-playlist__form__forminputscont">
                <BField
                  :type="errorMsg && !newPlaylist.name ? 'is-danger' : ''"
                  :message="errorMsg && !newPlaylist.name ? errorMsg : ''"
                  style="text-align: left"
                >
                  <BInput
                    v-model="newPlaylist.name"
                    type="text is-small inputelement"
                    placeholder="Introduce un nombre para la lista"
                    :maxlength="35"
                  />
                </BField>
                <BInput
                  v-model="newPlaylist.description"
                  class="is-small textareelement"
                  type="textarea"
                  placeholder="Agrega una descripción"
                  rows="4"
                  :maxlength="140"
                />
              </div>
            </div>
            <div class="create-playlist__btnscontent">
              <div class="btn-add-playlist-cancel-2" @click="clickCancelCreatePlaylist">
                Cancelar
              </div>
              <div class="btn-add-playlist-save-2 is-green" @click="clickSaveCreatePlaylist">
                Siguiente
              </div>
            </div>
          </div>
          <div v-if="showAddToPlaylist" class="add-to-playlist">
            <div class="add-to-playlist__header">
              <div class="add-to-playlist__header__title">
                <img src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_my_playlists_dark.svg" alt="" />
                <div>Agregar a playlist</div>
              </div>
              <div class="add-to-playlist__header__cont" @click="clickCloseModal">
                <img src="https://golstatsimages.blob.core.windows.net/todoelfut/close-blue.png" />
              </div>
            </div>
            <div class="add-to-playlist__container-playlist">
              <div
                v-for="playlist of userPlaylists"
                :key="playlist.playlist_id"
                class="add-to-playlist__container-playlist__item-playlist"
              >
                <div class="add-to-playlist__container-playlist__item-playlist__radio">
                  <BCheckbox v-model="playlist.isSelected" />
                </div>
                <div class="add-to-playlist__container-playlist__item-playlist__icon">
                  <img src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_folder_playlist.png" />
                </div>
                <div class="add-to-playlist__container-playlist__item-playlist__nametitle">
                  {{ playlist.name }}
                </div>
              </div>
            </div>
            <div class="add-to-playlist__menu">
              <div class="add-to-playlist__menu__cont-button">
                <div class="btn-add-playlist" @click="clickCreateNewPlaylist">
                  <img src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_add_folder_playlist.png" />
                  <div class="btn-add-playlist__title">Crear nueva lista</div>
                </div>
              </div>
              <div class="add-to-playlist__menu__cont-button-general">
                <div class="btn-add-playlist-cancel" @click="clickCancelAddToPlaylist">
                  Cancelar
                </div>
                <div
                  class="btn-add-playlist-save"
                  :class="{ 'save-disabled': !booleanIsAnyPlayListSelected }"
                  @click="clickNextAddToPlaylist"
                >
                  Siguiente
                </div>
              </div>
            </div>
          </div>
          <div v-if="showEditVideo" class="edit-video">
            <div v-if="isFromNewList" class="create-playlist__header">
              <div class="create-playlist__header__title">
                <img src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_add_folder_playlist@2x.png" />
                <span class="create-playlist__header__title__text">Crear playlist</span>
              </div>
              <div class="create-playlist__header__icon" @click="clickCloseModal">
                <img src="https://golstatsimages.blob.core.windows.net/todoelfut/close-blue.png" />
              </div>
            </div>
            <div v-else class="add-to-playlist__header">
              <div class="add-to-playlist__header__title">
                <img v-if="showEditVideoTool" src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_edit_video_todoelfut.png" />
                <img v-else src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_my_playlists_dark.svg" alt="" />
                <div>Agregar a playlist</div>
              </div>
              <div class="add-to-playlist__header__cont" @click="clickCloseModal">
                <img src="https://golstatsimages.blob.core.windows.net/todoelfut/close-blue.png" />
              </div>
            </div>
            <div class="edit-video__content">
              <div v-if="showEditVideoTool" class="edit-video__content__tool">
                <EditVideoTool :video-to-edit="playsToSaveAsFavorites[0] || []" @cancel="onCancel" @save="onSaveEdit" />
              </div>
              <div v-else class="edit-video__content__proposal">
                <div role="button" class="edit-video__content__proposal__button" @click="onClickEditTime">
                  Editar tiempo del video
                </div>
                <div role="button" class="edit-video__content__proposal__button is-green" @click="onClickSaveDefaults">
                  Guardar con tiempo predefinido
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </BModal>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import myPlaylistMixin from '@/mixins/my-playlist-mixin';
import axios from 'axios';
import { getPlayContentIndex } from '@/data/media-player-play-indexes';

const playContentIndex = getPlayContentIndex();

export default {
  name: 'CreatePlaylistModal',
  components: {
    EditVideoTool: () => import('@/components/Sections/MediaPlayer-v3/modal-mode/EditVideoTool'),
    BInput: async () => {
      const { BInput } = await import('buefy/dist/esm/input');
      return BInput;
    },
    BField: async () => {
      const { BField } = await import('buefy/dist/esm/field');
      return BField;
    },
    BModal: async () => {
      const { BModal } = await import('buefy/dist/esm/modal');
      return BModal;
    },
  },
  mixins: [myPlaylistMixin],
  data() {
    return {
      showCreateForm: false,
      showAddIcon: false,
      showAddToPlaylist: true,
      showEditVideo: false,
      showEditVideoTool: false,
      isFromNewList: false,
      playlistUrl: 'https://r6d08waisc.execute-api.us-east-2.amazonaws.com/prod/users/videos/playlists',
      newPlaylist: this.getEmptyPlaylist(),
      playlistImages: [
        'https://golstatsimages.blob.core.windows.net/golstats2-vr/recorridos_defensivos_03.png',
        'https://golstatsimages.blob.core.windows.net/golstats2-vr/recorridos_ofensivos_03.png',
        'https://golstatsimages.blob.core.windows.net/golstats2-vr/jugadas_defensivas.png',
        'https://golstatsimages.blob.core.windows.net/golstats2-vr/jugadas_ofensivas.png',
        'https://golstatsimages.blob.core.windows.net/golstats2-vr/salida_02.png',
        'https://golstatsimages.blob.core.windows.net/golstats2-vr/jugadas_por_las_bandas.png',
        'https://golstatsimages.blob.core.windows.net/golstats2-vr/perdida_de_balon_en_defensa.png',
        'https://golstatsimages.blob.core.windows.net/golstats2-vr/contraataque_02.png',
        'https://golstatsimages.blob.core.windows.net/golstats2-vr/participaciones_de_jugador.png',
        'https://golstatsimages.blob.core.windows.net/golstats2-vr/goles.png',
        'https://golstatsimages.blob.core.windows.net/golstats2-vr/lesiones_02.png',
        'https://golstatsimages.blob.core.windows.net/golstats2-vr/penales.png',
        'https://golstatsimages.blob.core.windows.net/golstats2-vr/saques%20de%20meta_02.png',
        'https://golstatsimages.blob.core.windows.net/golstats2-vr/balon_parado.png',
        'https://golstatsimages.blob.core.windows.net/golstats2-vr/tactica_fija.png',
        'https://golstatsimages.blob.core.windows.net/golstats2-vr/tiro_de_esquina.png',
        'https://golstatsimages.blob.core.windows.net/golstats2-vr/tiro_libre.png',
      ],
      selectedIconIndex: -1,
      selectedImageUrl: '',
      selectedImageUrlTmp: '',
      errorMsg: '',
      createdPlaylist: null,
      playlistsToAdd: [],
    };
  },
  computed: {
    ...mapState('mediaGeneral', ['playsToSaveAsFavorites']),
    ...mapState('mediaModal', ['currentPlayerQueue']),
    ...mapGetters('mediaGeneral', ['playsSaved']),
    ...mapState('loginGeneral', ['user']),
    ...mapState(['windowWidth']),
    booleanIsAnyPlayListSelected() {
      return this.userPlaylists.some(playList => playList.isSelected);
    },
    isModalOpen() {
      return this.$store.state.mediaModal.isModalCreatePlayListOpen;
    },
    isMobile() {
      return this.$mq === 'mobile';
    },
    formIconStyle() {
      if (this.selectedImageUrl) {
        return {
          'background-image': `url(${this.selectedImageUrl})`,
          'background-size': 'unset',
        };
      }
      return {
        'background-image': `url(https://golstatsimages.blob.core.windows.net/todoelfut/icn_image@2x.png)`,
      };
    },
    modalWidth() {
      return this.showEditVideo && this.showEditVideoTool ? '100%' : '571px';
    },
    modalMaxWidth() {
      return this.showEditVideo && this.showEditVideoTool ? '600px' : '571px';
    },
  },
  watch: {
    'user.id': {
      async handler(newValue, oldVale) {
        if (newValue !== oldVale) {
          await this.setUpUserPlaylists();
        }
      },
    },
    isModalOpen(newValue) {
      if (newValue && !this.userPlaylists.length) {
        this.setUpUserPlaylists();
      } else {
        this.errorMsg = '';
        this.resetModal();
        this.unselectPlaylists();
      }
    },
  },
  methods: {
    ...mapMutations('mediaModal', ['setIsModalCreatePlayListOpen']),
    ...mapMutations(['setIsSectionLoading']),
    /**
     *
     * @param {Object} body
     * @param {Number} body.user_id
     * @param {String} body.name
     * @param {String=} body.description
     * @param {String=} body.icon
     * @return {Promise<void>}
     */
    async createNewPlaylist(body) {
      let response = {};
      try {
        // eslint-disable-next-line no-undef
        response = await axios.post(
          'https://r6d08waisc.execute-api.us-east-2.amazonaws.com/prod/users/playlists',
          body,
        );
        return response.data && response.data.playlist ? response.data.playlist : null;
      } catch (e) {
        this.showError(e.response.data.message);
        return Promise.reject(e);
      }
    },
    getEmptyPlaylist() {
      return {
        name: '',
        description: '',
      };
    },
    resetModal() {
      this.clearSelectedImageUrl();
      this.createdPlaylist = null;
      this.newPlaylist = this.getEmptyPlaylist();
      this.showAddIcon = false;
      this.showCreateForm = false;
      this.showEditVideoTool = false;
      this.showEditVideo = false;
      this.showAddToPlaylist = true;
    },
    onCancel() {
      this.showEditVideoTool = false;
    },
    onClickClose() {
      this.$store.commit('mediaModal/setIsModalCreatePlayListOpen', false);
    },
    clickCreateNewPlaylist() {
      this.showCreateForm = true;
      this.showAddToPlaylist = false;
    },
    clickAddIconToPlaylist() {
      this.showCreateForm = false;
      this.showAddIcon = true;
    },
    clickCancelAddToPlaylist() {
      this.$store.commit('mediaModal/setIsModalCreatePlayListOpen', false);
    },
    clickNextAddToPlaylist() {
      if (this.booleanIsAnyPlayListSelected) {
        this.playlistsToAdd = this.userPlaylists.reduce((accumulator, playlist) => {
          if (playlist.isSelected) {
            accumulator.push(playlist.playlist_id);
          }
          return accumulator;
        }, []);
        if (this.playlistsToAdd.length) {
          this.showAddToPlaylist = false;
          this.showEditVideo = true;
        } else {
          this.showError('Selecciona una playlist para guardar el vídeo.');
        }
      }
    },
    async saveVideoToPlaylist() {
      let response = {};
      try {
        const playlistsIds = this.createdPlaylist ? [this.createdPlaylist.playlist_id] : this.playlistsToAdd;
        if (!playlistsIds.length) {
          return;
        }
        this.setIsSectionLoading(true);
        response = await axios.post(this.playlistUrl, {
          user_id: this.user.id,
          playlists_ids: playlistsIds,
          videos: this.playsToSaveAsFavorites,
        });
      } catch (e) {
        response = e.response;
      } finally {
        this.setIsSectionLoading(false);
        if (response.status === 200) {
          this.updateUserPlaylists(response.data.playlists);
          this.setIsModalCreatePlayListOpen(false);
          this.success();
        } else {
          this.showError(response.data.message);
        }
      }
    },
    updateUserPlaylists(newPlaylists) {
      newPlaylists.forEach(playlist => {
        const playlistAux = this.userPlaylists.find(userPlaylist => userPlaylist.playlist_id === playlist.playlist_id);
        if (playlistAux) {
          playlistAux.plays = playlist.playlists || playlist.playlist;
        }
      });
      this.currentPlayerQueue.forEach(play => {
        play.isSaved = this.playsSaved.has(play.playId);
      });
    },
    success() {
      this.$buefy.notification.open({
        message: 'El vídeo se agregó correctamente.',
        type: 'is-success',
      });
    },
    showError(msg) {
      this.$buefy.notification.open({
        duration: 6000,
        message: msg,
        type: 'is-danger',
      });
    },
    clearSelectedImageUrl() {
      this.selectedImageUrl = '';
      this.selectedImageUrlTmp = '';
    },
    clickCancelCreatePlaylist() {
      this.errorMsg = '';
      this.clearSelectedImageUrl();
      this.showCreateForm = false;
      this.showAddToPlaylist = true;
    },
    async clickSaveCreatePlaylist() {
      try {
        if (this.newPlaylist.name) {
          this.setIsSectionLoading(true);
          const body = { ...this.newPlaylist, user_id: this.user.id };
          if (this.selectedImageUrl) {
            body.icon = this.selectedImageUrl;
          }
          const newPlaylist = await this.createNewPlaylist(body);
          newPlaylist.plays = newPlaylist.playslists || newPlaylist.playlists || newPlaylist.playlist;
          newPlaylist.isSelected = true;
          this.userPlaylists.push(newPlaylist);
          this.createdPlaylist = newPlaylist;
          this.showCreateForm = false;
          this.showEditVideo = true;
        } else {
          this.errorMsg = 'El nombre es requerido.';
        }
      } catch (e) {
        throw new Error(e);
      } finally {
        this.setIsSectionLoading(false);
      }
    },
    saveAddIconToPlaylist() {
      this.selectedImageUrl = this.selectedImageUrlTmp;
      this.showCreateForm = true;
      this.showAddIcon = false;
    },
    backAddIconToPlaylist() {
      this.showCreateForm = true;
      this.showAddIcon = false;
    },
    clickCloseModal() {
      this.$store.commit('mediaModal/setIsModalCreatePlayListOpen', false);
    },
    onClickImage(imageUrl, imgIndex) {
      this.selectedIconIndex = imgIndex;
      this.selectedImageUrlTmp = imageUrl;
    },
    onClickEditTime() {
      this.showEditVideoTool = true;
    },
    onClickSaveDefaults() {
      this.saveVideoToPlaylist();
    },
    onSaveEdit(times) {
      const video = this.playsToSaveAsFavorites[0];
      if (times && video) {
        video[playContentIndex.startTime] = times.startTime;
        video[playContentIndex.endTime] = times.endTime;
      }
      this.saveVideoToPlaylist();
    },
  },
};
</script>
<style>
.input {
  font-family: 'Avenir-Demi';
  border: solid 1px #919ca8 !important;
  background-color: #fff !important;
  font-size: 16px !important;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.13;
  letter-spacing: -0.32px;
  text-align: left;
  color: #384753 !important;
}
.textarea {
  margin-top: 4px;
  border-radius: 8px;
  border: solid 1px #919ca8;
  background-color: #fff;
  font-size: 14px !important;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.29;
  letter-spacing: normal;
  text-align: left;
  color: #9ba6af;
  font-family: 'Avenir-Demi-Medium';
}
</style>
<style lang="scss" scoped>
.is-small-modal {
  height: 237px !important;
  @media screen and (max-width: 768px) {
    height: 332px !important;
  }
  @media screen and (max-width: 562px) {
    height: 288px !important;
  }
}
.is-big-modal {
  // height: 298px !important;
  // @media screen and (max-width: 768px) {
  //   height: 427px !important;
  // }
  // @media screen and (max-width: 562px) {
  //   height: 391px !important;
  // }
}
.item-icon-select {
  width: 80px;
  height: 80px;
  border-radius: 12px;
  overflow: unset;
  img {
    border-radius: 6px;
  }
  &.selected {
    border: solid 6px #03dffc !important;
  }
  &:hover {
    cursor: pointer;
    opacity: 0.92;
    border: solid 3px #75cf13;
  }
  @media screen and (max-width: 768px) {
    margin-left: 10px;
    margin-right: 10px;
  }
  @media screen and (max-width: 562px) {
    margin-left: 0px;
    margin-right: 0px;
  }
}
.add-img-playlist {
  width: 100%;
  height: auto;
  &__header {
    width: 100%;
    height: 36px;
    position: relative;
    border-bottom: dotted 1px #878e93;
    display: inline-flex;
    justify-content: space-between;
    align-items: center;
    align-content: center;
    padding: 0 5px 0 5px;
    @media screen and (max-width: 768px) {
      height: 100px;
      margin-top: -10px;
    }
    @media screen and (max-width: 562px) {
      height: 80px;
    }
    &__title {
      width: 80%;
      font-family: 'Avenir-Demi-Medium';
      font-size: 18px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: -0.36px;
      text-align: left;
      color: #132839;

      @media screen and (max-width: 768px) {
        font-size: 16px;
      }
      @media screen and (max-width: 562px) {
        font-size: 15px;
      }
      &__text {
        padding-left: 35px;
        @media screen and (max-width: 768px) {
          padding-left: 0px;
        }
      }
      @media screen and (max-width: 768px) {
        margin-top: 50px;
        width: 100%;
        margin-left: -5px;
        position: absolute;
        text-align: center;
      }
    }
    &__back {
      padding-bottom: 1em;
      &__button {
        display: flex;
        justify-content: center;
        width: fit-content;
        &:hover {
          cursor: pointer;
          background: rgba(203, 238, 107, 0.7);
        }
        padding: 0.2em 1.2em 0.2em 1.2em;
        border-radius: 20px;
        border: solid 1px #000;
        font-family: Roboto-Regular, sans-serif;
        font-size: 0.9375em;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: -0.15px;
        cursor: pointer;
        margin-top: 14px;
        @media screen and (max-width: 768px) {
          margin-top: 4px;
        }
        &__icon {
          margin-right: 0.5em;
        }
      }
    }
    &__icon {
      margin-top: 10px;
      @media screen and (max-width: 768px) {
        margin-top: -6px;
      }
    }
  }
  &__contimgs {
    width: 100%;
    //height: 168px;
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    grid-row-gap: 0.5em;
    margin-top: 5px;
    overflow-x: auto;

    & > div {
      justify-self: center;
    }

    @media screen and (max-width: 768px) {
      grid-template-columns: repeat(3, 1fr);
      max-height: 348px;
    }
  }
  &__btnscontent {
    width: 100%;
    height: 48px;
    margin-top: 14px;
    display: inline-flex;
    justify-content: right;
    align-items: center;
    align-content: center;
    @media screen and (max-width: 562px) {
      margin-top: 9px;
    }
  }
}
.create-playlist {
  width: 100%;
  height: auto;
  &__header {
    width: 100%;
    height: 46px;
    border-bottom: dotted 1px #878e93;
    display: inline-flex;
    justify-content: space-between;
    align-items: center;
    align-content: center;
    padding: 0px 5px 0px 5px;
    &__title {
      width: 80%;
      font-family: 'Avenir-Demi-Medium';
      font-size: 18px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: -0.36px;
      text-align: left;
      color: #132839;
      &__text {
        padding-left: 10px;
      }
      img {
        width: 28px;
        margin-top: 0px;
        float: left;
        @media screen and (max-width: 768px) {
          width: 28px;
          margin-top: 0px;
        }
      }
    }
    &__icon {
      margin-top: 5px;
    }
  }
  &__form {
    width: 100%;
    height: auto;
    margin-top: 12px;
    margin-bottom: 14px;
    display: inline-flex;
    justify-content: space-between;
    @media screen and (max-width: 768px) {
      display: inline-block;
      justify-content: center;
    }
    &__imgcont {
      width: 143px;
      height: 143px;
      margin-top: 5px;
      margin-left: 10px;
      border-radius: 8px;
      background-color: #e5e8eb;
      //background-image: url('https://golstatsimages.blob.core.windows.net/todoelfut/icn_image@2x.png');
      background-position: center center;
      background-repeat: no-repeat;
      background-size: 39px 39px;

      & > img {
        object-fit: fill;
      }
      &:hover {
        background-color: #bdc5ce;
        cursor: pointer;
      }
      @media screen and (max-width: 768px) {
        width: 94px;
        height: 94px;
        margin: 0 auto;
        margin-top: 8px;
      }
      @media screen and (max-width: 562px) {
        margin-top: -2px;
      }
    }
    &__forminputscont {
      width: 348px;
      height: auto;
      margin-top: 5px;
      margin-right: 10px;
      @media screen and (max-width: 768px) {
        width: 100%;
        margin-top: 16px;
      }
      @media screen and (max-width: 562px) {
        margin-top: 10px;
      }
    }
  }
  &__btnscontent {
    width: 100%;
    height: 48px;
    display: inline-flex;
    justify-content: right;
    align-items: center;
    align-content: center;
    @media screen and (max-width: 768px) {
      margin-top: 14px;
    }
    @media screen and (max-width: 562px) {
      margin-top: 6px;
    }
  }
}
.btn-add-playlist-cancel-3 {
  width: 186px;
  height: 48px;
  border-radius: 25px;
  border: solid 1px #132839;
  font-size: 19px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 48px;
  margin-right: 10px;
  letter-spacing: -0.38px;
  text-align: center;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  color: #132839;
  font-family: 'Avenir-Demi';
  &:hover {
    cursor: pointer;
    background: rgba(203, 238, 107, 0.7);
  }
  img {
    width: 33px;
    height: 33px;
  }
  &__text {
    margin-right: 10px;
  }
}
.btn-add-playlist-cancel-2 {
  width: 135px;
  height: 48px;
  border-radius: 25px;
  border: solid 1px #132839;
  font-size: 19px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 48px;
  margin-right: 10px;
  letter-spacing: -0.38px;
  text-align: center;
  color: #132839;
  font-family: 'Avenir-Demi';
  &:hover {
    cursor: pointer;
    background: rgba(203, 238, 107, 0.7);
  }
}
.btn-add-playlist-save-3 {
  width: 140px;
  height: 48px;
  border-radius: 25px;
  border: solid 1px #132839;
  font-size: 19px;
  font-weight: normal;

  font-stretch: normal;
  font-style: normal;
  line-height: 48px;
  letter-spacing: -0.38px;
  text-align: center;
  color: #132839;
  font-family: 'Avenir-Demi';
  &:hover {
    cursor: pointer;
    background: rgba(203, 238, 107, 0.7);
  }
}
.btn-add-playlist-save-2 {
  width: 145px;
  height: 48px;
  border-radius: 25px;
  border: solid 1px #132839;
  font-size: 19px;
  font-weight: normal;

  font-stretch: normal;
  font-style: normal;
  line-height: 48px;
  letter-spacing: -0.38px;
  text-align: center;
  color: #132839;
  font-family: 'Avenir-Demi';
  &:hover {
    cursor: pointer;
    background: rgba(203, 238, 107, 0.7);
  }
}
.btn-add-playlist-cancel {
  width: 123px;
  height: 44px;
  border-radius: 25px;
  border: solid 1px #132839;
  font-size: 19px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 44px;
  margin-right: 10px;
  letter-spacing: -0.38px;
  text-align: center;
  color: #132839;
  font-family: 'Avenir-Demi';
  &:hover {
    cursor: pointer;
    background: rgba(203, 238, 107, 0.7);
  }
  @media screen and (max-width: 768px) {
    width: 143px;
  }
}
.btn-add-playlist-save {
  width: 123px;
  height: 44px;
  border-radius: 25px;
  font-size: 19px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 44px;
  letter-spacing: -0.38px;
  text-align: center;
  color: #132839;
  font-family: 'Avenir-Demi', sans-serif;
  background-color: #cbee6b;
  border: solid 1px #cbee6b;
  cursor: pointer;
  @media screen and (max-width: 768px) {
    width: 143px;
  }

  &.save-disabled {
    opacity: 0.7;
    cursor: default;
    background: #f0f0f0;
    border: solid 1px #f0f0f0;
  }
}
.btn-add-playlist {
  width: 201px;
  height: 44px;
  border-radius: 9px;
  border: solid 1px #132839;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  &__title {
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1;
    letter-spacing: -0.32px;
    text-align: left;
    color: #132839;
    font-family: 'Avenir-Demi';
    padding-left: 12px;
  }
  &:hover {
    cursor: pointer;
    background: rgba(203, 238, 107, 0.7);
  }
  @media screen and (max-width: 768px) {
    width: 300px;
  }
  @media screen and (max-width: 562px) {
    width: 260px;
  }
}
.add-to-playlist {
  width: 100%;
  &__header {
    width: 100%;
    height: 46px;
    border-bottom: dotted 1px #878e93;
    display: inline-flex;
    justify-content: space-between;
    align-items: center;
    align-content: center;
    padding: 0px 5px 0px 5px;
    &__title {
      width: 80%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      font-family: 'Avenir-Demi-Medium';
      font-size: 18px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: -0.36px;
      text-align: left;
      color: #132839;

      & > img {
        margin-right: 10px;
      }
    }
    &__cont {
      width: 20%;
      img {
        float: right;
      }
      &:hover {
        cursor: pointer;
        opacity: 0.8;
      }
    }
  }
  &__container-playlist {
    width: 100%;
    height: 100px;
    margin-top: 6px;
    overflow: auto;
    @media screen and (max-width: 768px) {
      height: 134px;
      margin-top: 6px;
    }
    @media screen and (max-width: 562px) {
      height: 89px;
      margin-top: 3px;
    }
    &__item-playlist {
      width: 100%;
      height: 53px;
      border-bottom: dotted 1px #878e93;
      display: inline-flex;
      align-items: center;
      align-content: center;
      @media screen and (max-width: 768px) {
        height: 44px;
        margin-top: 1px;
      }
      &__radio {
        width: 8%;
        input {
          margin-top: 50px;
        }
        @media screen and (max-width: 768px) {
          width: 12%;
        }
        @media screen and (max-width: 562px) {
          width: 20%;
        }
      }
      &__icon {
        width: 10%;
        img {
          margin-top: 3px;
        }
        @media screen and (max-width: 768px) {
          width: 15%;
        }
        @media screen and (max-width: 562px) {
          width: 20%;
        }
      }
      &__nametitle {
        width: 77%;
        font-size: 15px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: -0.3px;
        text-align: left;
        color: #132839;
      }
    }
  }
  &__menu {
    width: 107%;
    height: 68px;
    margin-left: -6%;
    border-top: dotted 1px #b4b6b8;
    display: inline-flex;
    justify-content: left;
    align-items: center;
    align-content: center;
    &__cont-button {
      width: 50%;
    }
    &__cont-button-general {
      width: 50%;
      display: inline-flex;
      justify-content: right;
      align-items: center;
      align-content: center;
      @media screen and (max-width: 768px) {
        width: 100%;
        justify-content: space-between;
        margin-top: 12px;
      }
    }
    @media screen and (max-width: 768px) {
      display: inline-block;
      justify-content: center;
      margin-left: 0;
      width: 100%;
      height: 118px;
      padding-top: 18px;

      &__cont-button {
        width: 100%;

        & > .btn-add-playlist {
          width: 100%;
        }
      }
    }
  }
}
.create-playlist-modal {
  &__content {
    font-size: 1rem;
    border-radius: 0.5em;
    box-shadow: 0 16px 34px 0 rgba(0, 0, 0, 0.25);
    background-color: #fff;
    overflow: hidden;
    display: flex;
    padding: 10px 20px 10px 20px;
    flex-direction: column;
    align-items: center;
    position: relative;
    @media screen and (max-width: 768px) {
      width: 340px;
      margin: 0 auto;
    }
    @media screen and (max-width: 562px) {
      width: 300px;
      margin: 0 auto;
    }
    &__close-button {
      position: absolute;
      top: 4px;
      right: 4px;
      padding: 0.2em 1em;
      font-family: Roboto-Regular, sans-serif;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.47;
      letter-spacing: -0.15px;
      color: white;
      border-radius: 1.25em;
      background-color: #132839;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;

      & > div:first-child {
        margin-right: 0.8em;
      }

      & img {
        height: 0.6em;
        width: 0.6em;
      }
    }

    &__header {
      width: 100%;
    }

    &__body {
      margin-top: 1.5em;
      width: 100%;
    }
  }
}
.edit-video {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  &__content {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    &__tool {
      margin-top: 6px;
    }

    &__proposal {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 3.375em 0 3.2em;

      &__button {
        width: 75%;
        height: 2.9em;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: Avenir-Demi, sans-serif;
        border-radius: 10px;
        border: solid 1px #132839;
        font-size: 19px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 0.84;
        letter-spacing: -0.38px;
        color: #132839;
        cursor: pointer;

        &:last-child {
          margin-top: 0.52em;
        }

        @media screen and (max-width: 768px) {
          width: 100%;
        }

        @media screen and (max-width: 562px) {
          font-size: 16px;
        }
      }
    }
  }
}
.is-green {
  background-color: #cbee6b;
  border: solid 1px #cbee6b;
}
</style>
<style lang="scss">
#create-playlist-modal-dom {
  $primary: #132839;
  .b-checkbox.checkbox {
    float: right !important;
    margin-right: 1px;
    margin-top: -3px;
    width: 18px;
    background: #dfdfdf;
    border-radius: 4px;
  }
  .b-checkbox.checkbox input[type='checkbox'] {
    background: #dfdfdf;
    margin-left: 10px;
    float: right !important;
    border-color: red !important;
  }
  .b-checkbox.checkbox input[type='checkbox']:checked + .check {
    background: $primary
      url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath style='fill:white' d='M 0.04038059,0.6267767 0.14644661,0.52071068 0.42928932,0.80355339 0.3232233,0.90961941 z M 0.21715729,0.80355339 0.85355339,0.16715729 0.95961941,0.2732233 0.3232233,0.90961941 z'%3E%3C/path%3E%3C/svg%3E")
      no-repeat center center;
    border-color: $primary;
  }

  //.b-checkbox.checkbox:hover input[type='checkbox']:not(:disabled) + .check {
  //  border-color: $primary;
  //}
  //
  //.b-checkbox.checkbox input[type='checkbox']:focus:checked + .check {
  //  box-shadow: 0 0 0.5em rgba(145, 145, 145, 0.8);
  //}

  & .b-checkbox.checkbox:hover input[type='checkbox']:not(:disabled) + .check {
    border-color: #9bd73a;
  }

  & .b-checkbox.checkbox input[type='checkbox']:checked + .check {
    background: #9bd73a
      url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath style='fill:%23fff' d='M 0.04038059,0.6267767 0.14644661,0.52071068 0.42928932,0.80355339 0.3232233,0.90961941 z M 0.21715729,0.80355339 0.85355339,0.16715729 0.95961941,0.2732233 0.3232233,0.90961941 z'%3E%3C/path%3E%3C/svg%3E")
      no-repeat center center;
    border-color: #9bd73a;
  }

  .checkbox {
    width: 100%;
    text-align: start;
    padding-left: 0 !important;
  }

  p.help {
    margin: 0 !important;
  }

  & small.help {
    margin: 0 !important;
  }
}
</style>
